import React, { useMemo } from 'react'
import _ from 'lodash'
import SelectOrCreate from '../../components/form/SelectOrCreate'
import InputField from '../../components/form/InputField'
import loadingGif from '../../assets/img/loading-pinwheel.gif'
import { useForm, useField } from 'react-form'

function Field(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <InputField {...props} input={getInputProps()} />
}

function SelectField(props) {
  const { meta: { error, isTouched, isValidating }, getInputProps } = useField(props.name)
  return <SelectOrCreate {...props} input={getInputProps()} />
}

const SectionFormInline = props => {
  const { courseCollection, formValues, onSubmit, isSubmitting, errors } = props
  const { Form, values, meta } = useForm({
    defaultValues: useMemo(()=>formValues,[]),
    onSubmit: (values,instance)=>onSubmit(formatValues(values))
  })

  // Turns react-select-compatible values into values that the
  // API endpoint will understand
  const formatValues = vals => {
    const { course, ...rest } = vals
    if(!course){ return vals }

    if(course.__isNew__) {
      return { courseName: course.value, ...rest }
    } else {
      return { courseId: course.value, ...rest }
    }
  }

  return(
    <Form id='section-form'>
      <div className='row'>
        <div className='col-md-6'>
          <SelectField
            label='Course/Subject'
            name='course'
            placeholder='Type to create new or select existing'
            selectProps={{
              options:        courseCollection,
              isClearable:    true
            }}
          />
        </div>
        <div className='col-md-6'>
          <Field label='Class Name' name='name'/>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <Field label='Class Description' name='description'/>
        </div>
      </div>

      {meta.isTouched &&
        <button type='submit' disabled={isSubmitting} className='btn btn-primary'>Save</button>
      }
      <img className={`loading-gif ${(isSubmitting) ? '' : 'hidden'}`} src={loadingGif}/>
      {!_.isEmpty(errors) && <p className='error'>{errors}</p>}
    </Form>
  )
}

export default SectionFormInline
